import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import moment from 'moment';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';
import { recordFiltering } from '~/store/modules/operacaovazamento/actions';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';

function OperacaoVazamentoList() {
  const dispatch = useDispatch();

  const operacaovazamento = useSelector((state) => state.operacaovazamento);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: 'Data Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Data final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  const header = useMemo(
    () => [
      {
        id: 'movi_datahora_inicio',
        label: 'Inicio',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'movi_datahora_fim',
        label: 'Fim',
        formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'bico_numero',
        label: 'Bico',
        filter: {
          type: 'number',
        },
        align: 'right',
      },
      {
        id: 'movi_encerrante_inicial',
        label: 'Encer. Início',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'movi_encerrante_final',
        label: 'Encer. Fim',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },

      {
        id: 'movi_volume',
        label: 'Volume',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="movi_datahora_inicio ASC"
        create={false}
        delete={false}
        update={false}
        custom={filter}
        fixed
        header={header}
        redux={operacaovazamento}
        read={recordFiltering}
        detach="movi_codigo"
        view="VW_VAZAMENTO"
        reportTitle="Operação Vazamento"
      />
    </>
  );
}

export default OperacaoVazamentoList;
